var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{class:_vm.classTable,attrs:{"headers":_vm.headers,"items":_vm.pagamentos,"items-per-page":10},scopedSlots:_vm._u([{key:"item.valor",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getMoney(item.valor))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }